// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"fieldRenderers_checkboxLabel__7J882","customCheckbox":"fieldRenderers_customCheckbox__pUD1b","checkboxText":"fieldRenderers_checkboxText__P5irY"};